export enum ShopFeatureType {
  Labor = 'Labor',
  Tires = 'Tires',
  ServiceCategories = 'ServiceCategories'
}
